import {
	CLASSIC_BOARD,
	COMPANY_MANAGED_BOARD,
} from '@atlassian/jira-capabilities/src/constants.tsx';

export const classicBoardCapability = !__SERVER__ ? COMPANY_MANAGED_BOARD : CLASSIC_BOARD;
